<template>
<div id="home-page">
    <div class="row m-0 pl-md-5 pr-md-5 down white zIndexTwo">
        <div class="col-lg-6 text-left" >
            <h1 class="pt-5 pb-5" id="headline">Jouw beveiliging, <br />waar en wanneer jij wilt.</h1>
            <div class="row">
                <article class="col-md-6 mb-5" id="opdrachtgever">
                    <h2>Opdrachtgever<br />
                        <small class="text-muted invisible-sm">Particulier, zakelijk (beveiligingsbedrijf).</small>
                    </h2>
                    <p class="pt-3 mb-0">
                        Huur <router-link tag="a" :to="{ name: 'InformationSecurity'}" aria-label="Meer informatie over onze beveiligingsdiensten.">de beste beveiligers</router-link>, <router-link tag="a" :to="{ name: 'InformationTrafficSupport'}" aria-label="Meer informatie over onze verkeersdiensten.">verkeersregelaars</router-link>, brandwachten of <router-link tag="a" :to="{ name: 'InformationFirstAid'}" aria-label="Meer informatie over onze EHBO diensten.">EHBO-ers</router-link> voor jou klus. Maak een planning en ontvang direct de offerte.
                    </p>
                    <router-link :to="{ name: 'InformationClient' }" tag="a" aria="Meer informatie voor opdrachtgevers.">Meer Informatie...</router-link>
                </article>
                <article class="col-md-6 mb-5" id="beveiliger">
                    <h2>Beveiliger<br />
                        <small class="text-muted invisible-sm">Verkeersregelaar, EHBO of brandwacht.</small>
                    </h2>
                    <p class="pt-3 mb-0">Bepaal je eigen tarief en werkterrein in loondienst of als freelancer. Ook voor verkeersregelaars, brandwachten en EHBO-ers.</p>
                    <router-link :to="{ name: 'InformationProfessional' }" tag="a" aria-label="Meer informatie voor Beveiligers.">Meer Informatie...</router-link>
                </article>
            </div>
            <register-btns></register-btns>
        </div>
        <div class="col-lg-6 text-center mb-5">
            <img src="@/assets/beveiliging/beveiliger-600.webp" class="img-fluid" alt="Azurity Beveiliging" title="Azurity Beveiliging" />
        </div>
    </div>

    <article class="row bg-azure-light m-0 p-5 down light" id="safety">
        <div class="col-md-4 offset-md-2 text-center vert-center  mt-5 mb-5 mt-md-0 mb-md-0">
            <font-awesome-icon icon="mobile-alt" :size="$store.getters.isSmall ? '3x' : '7x'"  />
        </div>
        <div class="col-md-4 text-left">
            <h3>Dé beveiligingsbranche App</h3>
            <p>Azurity verbindt veiligheidsprofessionals en opdrachtgevers en levert slimme software tools voor een eenvoudige bedrijfsvoering.</p> 
            <div class="row">
                <div class="col-md-4 text-center mb-3">
                    <a href="https://app.azurity.nl" target="_blank">
                        <img src="@/assets/pwa-badge-sm.png" alt="Progressive Web App" height="45" width="140"  />
                    </a>
                </div>
                <div class="col-md-4 text-center mb-3">
                    <a href="https://play.google.com/store/apps/details?id=nl.azurity.app" target="_blank">
                        <img src="@/assets/google-play-badge-sm.png" alt="Google Play Store" height="45" width="140"  />
                    </a>
                </div>
                <div class="col-md-4 text-center mb-3">
                    <a href="https://app.azurity.nl" target="_blank">
                        <img src="@/assets/ios-badge-sm.png" alt="Slaapp Logo" height="45" width="140"  />
                    </a>
                </div>
            </div>
        </div>
    </article>
    <article class="row m-0 p-5 down white zIndexOne" id="safety">
        <div class="col-md-4  text-center vert-center  order-md-2  mt-5 mb-5 mt-md-0 mb-md-0">
            <font-awesome-icon icon="shield-alt" :size="$store.getters.isSmall ? '3x' : '7x'"  />
        </div>
        <div class="col-md-4 offset-md-2 text-left  order-md-1">
            <h3>Vrijheid & Veiligheid</h3>
            <p>Een veilige en flexibele omgeving waar vraag, aanbod, planning, service, informatie & betaling van <router-link tag="a" :to="{ name: 'InformationSecurity'}" aria-label="Meer informatie over onze beveiligingsdiensten.">beveiligingsdiensten</router-link> samen komen.</p>
        </div>
    </article>
    <article class="row bg-azure-light m-0 p-5 down light" id="review">
        <div class="col-md-4 offset-md-2 text-center vert-center  mt-5 mb-5 mt-md-0 mb-md-0">
            <score :size="$store.getters.isSmall ? 'fa-1x' : 'fa-3x'" :showQty="false" :score="0"></score>
        </div>
        <div class="col-md-4 text-left">
            <h3>Wij luisteren...!</h3>
            <p>5-sterren service! Laat direct weten of de professionele dienst voldoet aan de verwachting. Jouw review helpt ons in het aanbod van de beste professionele beveiligers.</p>
        </div>
    </article>
    <article class="row m-0 p-5 down white zIndexTwo" id="referral">
        <div class="col-md-4  text-center vert-center  order-md-2  mt-5 mb-5 mt-md-0 mb-md-0">
            <font-awesome-icon icon="euro-sign" :size="$store.getters.isSmall ? '3x' : '7x'" class="mr-2"  />
        </div>
        <div class="col-md-4 offset-md-2 text-left  order-md-1">
            <h3>Verdien extra!</h3>
            <p>Omdat we samen het platform succesvol maken, willen we je daarvoor ook belonen! Wanneer je een nieuwe professional of opdrachtgever aanbrengt, kun je <b>tot wel € 925,50 extra verdienen per doorverwijziging</b> per jaar. <router-link :to="{ name: 'SecurityReferral' }" aria-label="Lees meer over ons doorverwijsprogramma.">Lees meer...</router-link></p>
        </div>
    </article>
    <article class="row bg-azure-light m-0 p-5 down light zIndexOne" id="identity-app">
        <div class="col-md-4 offset-md-2 text-center vert-center  mt-5 mb-5 mt-md-0 mb-md-0">
            <font-awesome-icon icon="users" :size="$store.getters.isSmall ? '3x' : '7x'"  />
        </div>
        <div class="col-md-4 text-left">
            <h3>Flexibele Inhuur</h3>
            <p>Door ons unieke concept en platform is het mogelijk om binnen de vigerende wet- en regelgeving op een flexibele wijze personeel in te lenen.</p>
            <p>Door uw inhuur aan te melden als opdrachtgever op ons platform, wordt de betreffende afdeling Korpschefzaken van de Politie, automatisch geinformeerd en zijn de gegevens middels de <a href="https://id.azurity.nl" target="_blank" rel="noreferrer">Azurity Identity App</a> veilig op te vragen voor burger en Politie.</p>
        </div>
    </article>
</div>
</template>

<script>
import RegisterButtons from '@/components/RegisterButtons';
import Score from '@/components/Score';
export default {
    components: {
        'register-btns': RegisterButtons,
        Score
    }
}
</script>
<style scoped>
h1, h2 {
    font-weight: bold;
}

small.text-muted {
    font-size: .45em;
    text-transform: uppercase;
}
</style>